
import {getServerEndPoint} from "../webEndPoint";
import {getSavedLoginData} from "../../globalMethods/myConfig";

async function userSessionChecker( userCode) {

   const userToken = getSavedLoginData("user-token");
    try {
        const response = await fetch( getServerEndPoint() +"user-check/profile", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ "userToken": userToken, "userCode" : userCode }),
        });

        return  await response.json();
    } catch (err) {
        console.error("Check failed:", err);
    }
    return { valid: true, message: "Session check failed"};
}

export default userSessionChecker;